(() => {
  const icons = {
    star: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m12 3 2.7 5.5 6.1.9-4.4 4.3 1 6.1-5.4-2.9-5.4 2.9 1-6.1-4.4-4.3 6.1-.9L12 3z"/></svg>',
    clipboard: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="4" width="14" height="17" rx="2"/><path d="M9 4.5V3h6v1.5M8 9h8M8 13h8M8 17h5"/></svg>',
    leaf: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M19.5 4.5C12 4 6 7.5 6 13c0 3 2 5 5 5 5.5 0 8.5-6 8.5-13.5z"/><path d="M5 20c2.5-5 6-8 11-10"/></svg>',
    box: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m4 7 8-4 8 4-8 4-8-4z"/><path d="M4 7v10l8 4 8-4V7M12 11v10"/></svg>',
    info: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg>'
  };

  const typeForHeading = (text) => {
    const value = (text || '').toLowerCase();
    if (/benefit|feature|why|highlight|good for/.test(value)) return 'star';
    if (/ingredient|nutrition|formula|allergen/.test(value)) return 'leaf';
    if (/how to|direction|usage|use|serving/.test(value)) return 'clipboard';
    if (/pack|content|size|storage|specification|specs/.test(value)) return 'box';
    return 'info';
  };

  const addHeadingIcon = (heading) => {
    if (heading.querySelector('.sd-detail-heading__icon')) return;
    const type = typeForHeading(heading.textContent);
    const icon = document.createElement('span');
    icon.className = `sd-detail-heading__icon sd-detail-heading__icon--${type}`;
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = icons[type] || icons.info;
    heading.prepend(icon);
    heading.classList.add('sd-detail-heading');
  };

  const meaningfulNodes = (nodeList) => Array.from(nodeList).filter((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) return true;
    return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
  });

  const getContentRoot = (root) => {
    const directB2B = root.querySelector(':scope > .b2b-product-description');
    if (directB2B) return directB2B;
    const directMeta = root.querySelector(':scope > .metafield-rich_text_field');
    if (directMeta) return directMeta;
    if (root.children.length === 1) {
      const only = root.firstElementChild;
      if (only && only.querySelector('h2,h3,h4')) return only;
    }
    return root;
  };

  const organizeSections = (root) => {
    const content = getContentRoot(root);
    if (!content || content.dataset.sdDetailGridReady === 'true') return;

    const children = meaningfulNodes(content.childNodes);
    const directHeadings = children.filter((node) => node.nodeType === Node.ELEMENT_NODE && /^(H2|H3)$/.test(node.tagName));
    const fallbackHeadings = directHeadings.length ? [] : children.filter((node) => node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H4');
    const headingNodes = new Set(directHeadings.length ? directHeadings : fallbackHeadings);

    if (!headingNodes.size) {
      content.classList.add('sd-detail-grid', 'sd-detail-grid--single');
      const section = document.createElement('section');
      section.className = 'sd-detail-section sd-detail-section--wide';
      children.forEach((node) => section.appendChild(node));
      if (section.childNodes.length) content.appendChild(section);
      content.dataset.sdDetailGridReady = 'true';
      return;
    }

    const fragment = document.createDocumentFragment();
    let section = null;
    let sectionCount = 0;

    const createSection = (extraClass = '') => {
      const el = document.createElement('section');
      el.className = `sd-detail-section${extraClass ? ` ${extraClass}` : ''}`;
      fragment.appendChild(el);
      sectionCount += 1;
      return el;
    };

    children.forEach((node) => {
      if (headingNodes.has(node)) {
        section = createSection();
        section.appendChild(node);
        return;
      }
      if (!section) section = createSection('sd-detail-section--intro');
      section.appendChild(node);
    });

    Array.from(fragment.children).forEach((item) => {
      if (item.querySelector('table, img, video, iframe, model-viewer, .shopify-video')) {
        item.classList.add('sd-detail-section--wide');
      }
    });

    content.replaceChildren(fragment);
    content.classList.add('sd-detail-grid');
    if (sectionCount <= 1) content.classList.add('sd-detail-grid--single');
    content.dataset.sdDetailGridReady = 'true';
  };

  const enhance = (root) => {
    root.querySelectorAll('.sd-product-details__content h2, .sd-product-details__content h3, .sd-product-details__content h4, .description-extension h2, .description-extension h3, .description-extension h4').forEach(addHeadingIcon);
    root.querySelectorAll('.sd-product-details__content, .product__description.description-extension').forEach(organizeSections);
  };

  const run = () => enhance(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
